export const GET_HOTEL_REQUEST = 'GET_HOTEL_REQUEST';
export const GET_HOTEL_SUCCESS = 'GET_HOTEL_SUCCESS';
export const GET_HOTEL_FAILURE = 'GET_HOTEL_FAILURE';